import { Object } from "core-js";

export default Object.freeze({
    PreDeliveryRedirection: 'Redirect your parcel to an Easipik locker',
    MissedDeliveryForm: 'Missed Delivery Form'
});